import { create } from "zustand";

export interface LiveChatState {
  isOpenPopup: boolean;
  setIsOpenPopup: (value: boolean) => void;
  /** What sits at the bottom of the screen under the chat button, by key
   * (useChatBottomInset): the plan page's order bar, the checkout's Pay bar,
   * the cookie banner. The button sits above the tallest. */
  bottomInsets: Record<string, number>;
  setBottomInset: (key: string, value: number) => void;
}

export const useLiveChatStore = create<LiveChatState>(set => ({
  isOpenPopup: false,
  setIsOpenPopup: (value: boolean) => {
    set({
      isOpenPopup: value,
    });
  },
  bottomInsets: {},
  setBottomInset: (key: string, value: number) => {
    set(state =>
      (state.bottomInsets[key] ?? 0) === value
        ? state
        : { bottomInsets: { ...state.bottomInsets, [key]: value } },
    );
  },
}));

export const useLiveChatState = (): LiveChatState => {
  return useLiveChatStore(state => {
    return state;
  });
};
